export const CHOOSE_LOCATION_COLOR = Styles.color.primary;
